<template>
  <div :class="$style['drawer-navigation-list']">
    <div
      v-if="showBack"
      :class="[
        $style['drawer-navigation-list__item'],
        $style['drawer-navigation-list__item--back']
      ]"
      @click="$emit('back')">
      <svg-icon name="System/arrow-left-s-line" />
      {{ $t('general/go-back') }}
    </div>
    <template v-for="item in items">
      <NuxtLink
        v-if="!item.subItems?.length"
        :key="item.id"
        :to="{
          path: item.subItems?.length ? '' :
            `/${$lang}/${item.slug}`
        }"
        :class="[
          route.path === `/${$lang}/${item.slug}` ? $style['drawer-navigation-list__item--active'] : null,
          $style['drawer-navigation-list__item']
        ]">
        {{ item.title ?? item[0].title }}
        <svg-icon
          v-if="item.subItems.length"
          name="System/arrow-right-s-line" />
      </NuxtLink>
      <div
        v-else
        :key="`div-${item.id}`"
        :class="[
          route.path.includes(`${$lang}/${item.slug}`) ? $style['drawer-navigation-list__item--active']: null,
          $style['drawer-navigation-list__item'],
        ]"
        @click="$emit('select', item)">
        {{ item.title ?? item[0].title }}
        <svg-icon
          v-if="item.subItems?.length"
          name="System/arrow-right-s-line" />
      </div>
    </template>
  </div>
</template>
<script setup>
const route = useRoute()
defineEmits(['select', 'back'])
defineProps({
  items: {
    type: [Array, Object],
    default: null
  },
  showBack: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" module>

.drawer-navigation-list {
  display: flex;
  flex-direction: column;

  &__item {
    align-items: center;
    color: var(--grey-dark);
    cursor: pointer;
    justify-content: space-between;
    display: flex;
    font-size: var(--font-size);
    font-weight: var(--font-weight-bold);
    line-height: calc(var(--line-height) * 2);
    text-align: left;
    padding: 0 calc(var(--spacing ) * 2);
    text-decoration: none;
    width: 100%;

    &:hover {
      color: var(--black);
    }

    &--active {

      color: var(--black);
      font-weight: var(--font-weight-bold);
    }

    &--back {
      font-size: var(--font-size);
      justify-content: flex-start;

      &:focus,
      &:hover {
        color: var(--grey);
      }
    }
  }

  .router-link-exact-active{
    background-color: var(--grey-lightest)
  }
}
</style>
